import { model, Model, view } from 'mst-collection';
import { types } from 'mobx-state-tree';

import { VideoPlayerMemoryItemModel } from './VideoPlayerMemoryItemModel';

export class VideoPlayerMemory extends Model({
  items: types.map(VideoPlayerMemoryItemModel),
}) {
  setItem({ id, position }: { id: number; position: number }) {
    this.items.set(id.toString(), { id, position });
  }

  @view
  getItem(id: number) {
    return this.items.get(id.toString());
  }

  resetItem(id: number) {
    this.items.delete(id.toString());
  }
}

export const VideoPlayerMemoryModel = model(VideoPlayerMemory);
